/**
 * Form hook — creates useAppForm, withForm, and withFieldGroup
 * with our pre-registered field and form components.
 */
import { createFormHook } from '@tanstack/react-form'

import { fieldContext, formContext } from '@/frontend/components/form/form-context'

import { ConfirmSubmitButton } from './components/confirm-submit-button'
import { FormDebug } from './components/form-debug'
import { FormGlobalError } from './components/form-global-error'
import { SubmitButton } from './components/submit-button'
import {
  CheckboxField,
  CheckboxGroupField,
  ComboboxField,
  CurrencyField,
  DateInputField,
  DatePickerField,
  DateTimePickerField,
  InputField,
  MultiComboboxField,
  NumericInputField,
  PhoneInputField,
  RadioGroupField,
  RichTextField,
  SelectField,
  TextareaField,
  TimePickerField,
  ToggleGroupField,
} from './fields'

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: {
    CheckboxField,
    CheckboxGroupField,
    ComboboxField,
    CurrencyField,
    DateInputField,
    DatePickerField,
    DateTimePickerField,
    InputField,
    MultiComboboxField,
    NumericInputField,
    PhoneInputField,
    RadioGroupField,
    RichTextField,
    SelectField,
    TextareaField,
    TimePickerField,
    ToggleGroupField,
  },
  formComponents: {
    SubmitButton,
    ConfirmSubmitButton,
    GlobalError: FormGlobalError,
    FormDebug,
  },
  fieldContext,
  formContext,
})
